import React from "react";
import Header from "../components/Header";
import { Head } from "../components/Head";
import { Container } from "../styles/Container.styled";
import styled from "styled-components";
import "../styles/main.css";

const Privacy = () => {
	return (
		<>
			<Head titleSuffix={"Privacy Policy"} />
			<Header pageTilte={"Privacy Policy"} />
			<ContentContainer>
				<Content>
					<br />
					<h3>I. Important Introduction to Our Privacy Policy</h3>
					<br />
					<p>
						This Privacy Policy explains how Swipr Corporation (“Swipr” “we”,
						“our”, or “us”), the company that operates Witz, collects, uses,
						shares, and stores your information when you use the Witz website
						and/or the mobile applications that link to this Privacy Policy
						(“Services”). When you use our Services, you are agreeing to our
						rules and policies, including this Privacy Policy and Terms of Use,
						and you consent to our collecting, processing, and storing of your
						information as described below. You must not access or use the
						Services if you do not agree with our Privacy Policy. You should
						also read our Terms of Service because they also apply to your use
						of the Services.
					</p>
					<br />
					<h3>II. Information We Collect</h3>
					<br />
					<p>There are three basic categories of information we collect:</p>
					<ul>
						<li>Information you choose to give us.</li>
						<br />
						<li>Information we get when you use our Services.</li>
						<br />
						<li>Information we get from third parties.</li>
					</ul>
					<br />
					<p>Here’s a little more detail on each of these categories.</p>
					<br />
					<h3>Information You Choose to Give Us</h3>
					<br />
					<p>
						We collect personal information that you voluntarily provide to us
						when you express an interest in obtaining information about us or
						our products and Services, when you participate in activities on the
						Services, or otherwise when you contact us.
					</p>
					<br />
					<p>
						<strong>Personal Information Provided by You.</strong> The personal
						information that we collect depends on the context of your
						interactions with us and the Services, the choices you make, and the
						products and features you use. The personal information we collect
						may include the following:
					</p>
					<ul>
						<li>
							images you uploaded for plus the underlying text on those images
						</li>
						<br />
						<li>email address and name if you contact us via email</li>
					</ul>
					<p>
						<strong>Sensitive Information.</strong> We do not process sensitive
						information.
					</p>
					<p>
						<strong>Payment Data.</strong> We may collect data necessary to
						process your payment if you make purchases, such as your payment
						instrument number, and the security code associated with your
						payment instrument. All payment data is stored by Apple and Google.
						You may find their privacy notice link(s) here:
						<div>
							https://www.apple.com/legal/privacy/data/en/app-store/ and
						</div>
						<div>https://policies.google.com/privacy.</div>
					</p>
					<p>
						<strong>Application Data.</strong> If you use our application(s), we
						also may collect the following information if you choose to provide
						us with access or permission:
					</p>
					<ul>
						<li>
							<em>Mobile Device Data.</em> We automatically collect device
							information (such as your mobile device ID, model, and
							manufacturer), operating system, version information and system
							configuration information, device and application identification
							numbers, browser type and version, hardware model Internet service
							provider and/or mobile carrier, and Internet Protocol (IP) address
							(or proxy server). If you are using our application(s), we may
							also collect information about the phone network associated with
							your mobile device, your mobile device’s operating system or
							platform, the type of mobile device you use, your mobile device’s
							unique device ID, and information about the features of our
							application(s) you accessed.
						</li>
						<br />
						<li>
							<em>Push Notifications.</em> We may request to send you push
							notifications regarding your account or certain features of the
							application(s). If you wish to opt out from receiving these types
							of communications, you may turn them off in your device's
							settings.
						</li>
						<br />
					</ul>
					<p>
						This information is primarily needed to maintain the security and
						operation of our application(s), for troubleshooting, and for our
						internal analytics and reporting purposes.
					</p>
					<p>
						All personal information that you provide to us must be true,
						complete, and accurate, and you must notify us of any changes to
						such personal information.
					</p>
					<br />
					<h3>Information We Get When You Use Our Services</h3>
					<br />
					<p>
						We automatically collect certain information when you visit, use, or
						navigate the Services. This information does not reveal your
						specific identity (like your name or contact information) but may
						include device and usage information, such as your IP address,
						browser and device characteristics, operating system, language
						preferences, referring URLs, device name, country, location,
						information about how and when you use our Services, and other
						technical information. This information is primarily needed to
						maintain the security and operation of our Services, and for our
						internal analytics and reporting purposes.
					</p>
					<p>
						Like many businesses, we also collect information through cookies
						and similar technologies.
					</p>
					<p>The information we collect includes:</p>
					<ul>
						<li>
							<em>Log and Usage Data.</em> Log and usage data is
							service-related, diagnostic, usage, and performance information
							our servers automatically collect when you access or use our
							Services and which we record in log files. Depending on how you
							interact with us, this log data may include your IP address,
							device information, browser type, and settings and information
							about your activity in the Services (such as the date/time stamps
							associated with your usage, pages and files viewed, searches, and
							other actions you take such as which features you use), device
							event information (such as system activity, error reports
							(sometimes called "crash dumps"), and hardware settings).
						</li>
						<br />
						<li>
							<em>Device Data.</em> We collect device data such as information
							about your computer, phone, tablet, or other device you use to
							access the Services. Depending on the device used, this device
							data may include information such as your IP address (or proxy
							server), device and application identification numbers, location,
							browser type, hardware model, Internet service provider and/or
							mobile carrier, operating system, and system configuration
							information.
						</li>
						<br />
						<li>
							<em>Location Data.</em> We collect location data such as
							information about your device's location, which can be either
							precise or imprecise. How much information we collect depends on
							the type and settings of the device you use to access the
							Services. For example, we may use GPS and other technologies to
							collect geolocation data that tells us your current location
							(based on your IP address). You can opt out of allowing us to
							collect this information either by refusing access to the
							information or by disabling your Location setting on your device.
							However, if you choose to opt out, you may not be able to use
							certain aspects of the Services.
						</li>
					</ul>
					<br />
					<h3>Information We Collect from Third Parties</h3>

					<p>
						We may collect information about you from other users and third
						parties. For example, if another user uploads their contact list, we
						may combine information from that user’s contact list with other
						information we have collected about you.
					</p>
					<br />
					<h3>III. How We Use Information</h3>
					<br />
					<p>
						We process your personal information for a variety of reasons,
						depending on how you interact with our Services, including:
					</p>
					<br />
					<ul>
						<li>
							<strong>
								To deliver and facilitate the delivery of services to the user.
							</strong>{" "}
							We may process your information to provide you with the requested
							service.
						</li>
						<br />
						<li>
							<strong>
								To respond to user inquiries/offer support to users.
							</strong>{" "}
							We may process your information to respond to your inquiries and
							solve any potential issues you might have with the requested
							service.
						</li>
						<br />
						<li>
							<strong>To send administrative information to you.</strong> We may
							process your information to send you details about our products
							and services, changes to our terms and policies, and other similar
							information.
						</li>
						<br />
						<li>
							<strong>To fulfill and manage your orders.</strong> We may process
							your information to fulfill and manage your orders, payments,
							returns, and exchanges made through the Services.
						</li>
						<br />
						<li>
							<strong>To request feedback.</strong> We may process your
							information when necessary to request feedback and to contact you
							about your use of our Services.
						</li>
						<br />
						<li>
							<strong>To protect our Services.</strong> We may process your
							information as part of our efforts to keep our Services safe and
							secure, including fraud monitoring and prevention.
						</li>
						<br />
						<li>
							<strong>To identify usage trends.</strong> We may process
							information about how you use our Services to better understand
							how they are being used so we can improve them.
						</li>
						<br />
						<li>
							<strong>
								To determine the effectiveness of our marketing and promotional
								campaigns.
							</strong>{" "}
							We may process your information to better understand how to
							provide marketing and promotional campaigns that are most relevant
							to you.
						</li>
						<br />
						<li>
							<strong>
								To save or protect an individual's vital interest.
							</strong>{" "}
							We may process your information when necessary to save or protect
							an individual’s vital interest, such as to prevent harm.
						</li>
						<br />
					</ul>
					<br />
					<h3>IV. Legal Bases for Processing Your Information</h3>
					<br />
					<h3>For EU/UK residents:</h3>
					<br />
					<p>
						The General Data Protection Regulation (GDPR) and UK GDPR require us
						to explain the valid legal bases we rely on in order to process your
						personal information. As such, we may rely on the following legal
						bases to process your personal information:
					</p>
					<ul>
						<li>
							<strong>Consent.</strong> We may process your information if you
							have given us permission (i.e., consent) to use your personal
							information for a specific purpose. You can withdraw your consent
							at any time.
						</li>
						<br />
						<li>
							<strong>Performance of a Contract.</strong> We may process your
							personal information when we believe it is necessary to fulfill
							our contractual obligations to you, including providing our
							Services or at your request prior to entering into a contract with
							you.
						</li>
						<br />
						<li>
							<strong>Legitimate Interests.</strong> We may process your
							information when we believe it is reasonably necessary to achieve
							our legitimate business interests and those interests do not
							outweigh your interests and fundamental rights and freedoms. For
							example, we may process your personal information for some of the
							purposes described in order to:
							<ul>
								<br />
								<li>
									Analyze how our Services are used so we can improve them to
									engage and retain users
								</li>
								<br />
								<li>Support our marketing activities</li>
								<br />
								<li>Diagnose problems and/or prevent fraudulent activities</li>
								<br />
								<li>
									Understand how our users use our products and services so we
									can improve user experience
								</li>
								<br />
							</ul>
						</li>
						<br />
						<li>
							<strong>Legal Obligations.</strong> We may process your
							information where we believe it is necessary for compliance with
							our legal obligations, such as to cooperate with a law enforcement
							body or regulatory agency, exercise or defend our legal rights, or
							disclose your information as evidence in litigation in which we
							are involved.
						</li>
						<br />
						<li>
							<strong>Vital Interests.</strong> We may process your information
							where we believe it is necessary to protect your vital interests
							or the vital interests of a third party, such as situations
							involving potential threats to the safety of any person.
						</li>
					</ul>
					<br />
					<h3>For Canada residents:</h3>
					<br />
					<p>
						We may process your information if you have given us specific
						permission (i.e., express consent) to use your personal information
						for a specific purpose, or in situations where your permission can
						be inferred (i.e., implied consent). You can withdraw your consent
						at any time.
					</p>
					<p>
						In some exceptional cases, we may be legally permitted under
						applicable law to process your information without your consent,
						including, for example:
					</p>
					<ul>
						<li>
							If collection is clearly in the interests of an individual and
							consent cannot be obtained in a timely way
						</li>
						<br />
						<li>For investigations and fraud detection and prevention</li>
						<br />
						<li>
							For business transactions provided certain conditions are met
						</li>
						<br />
						<li>
							If it is contained in a witness statement and the collection is
							necessary to assess, process, or settle an insurance claim
						</li>
						<br />
						<li>
							For identifying injured, ill, or deceased persons and
							communicating with next of kin
						</li>
						<br />
						<li>
							If we have reasonable grounds to believe an individual has been,
							is, or may be victim of financial abuse
						</li>
						<br />
						<li>
							If it is reasonable to expect collection and use with consent
							would compromise the availability or the accuracy of the
							information and the collection is reasonable for purposes related
							to investigating a breach of an agreement or a contravention of
							the laws of Canada or a province
						</li>
						<br />
						<li>
							If disclosure is required to comply with a subpoena, warrant,
							court order, or rules of the court relating to the production of
							records
						</li>
						<br />
						<li>
							If it was produced by an individual in the course of their
							employment, business, or profession and the collection is
							consistent with the purposes for which the information was
							produced
						</li>
						<br />
						<li>
							If the collection is solely for journalistic, artistic, or
							literary purposes
						</li>
						<br />
						<li>
							If the information is publicly available and is specified by the
							regulations
						</li>
						<br />
					</ul>
					<br />
					<h3>V. How We Share Information</h3>
					<br />
					<p>
						We may share your data with third-party vendors, service providers,
						contractors, or agents ("third parties") who perform services for us
						or on our behalf and require access to such information to do that
						work. We have contracts in place with our third parties, which are
						designed to help safeguard your personal information. This means
						that they cannot do anything with your personal information unless
						we have instructed them to do it. They will also not share your
						personal information with any organization apart from us. They also
						commit to protect the data they hold on our behalf and to retain it
						for the period we instruct. The categories of third parties we may
						share personal information with are as follows:
					</p>
					<ul>
						<li>Cloud Computing Services</li>
						<br />
						<li>Communication & Collaboration Tools</li>
						<br />
						<li>Performance Monitoring Tools</li>
						<br />
						<li>Payment Processors</li>
						<br />
						<li>Order Fulfillment Service Providers</li>
						<br />
						<li>Data Analytics Services</li>
						<br />
						<li>Product Engineering & Design Tools</li>
						<br />
						<li>Website Hosting Service Providers</li>
						<br />
						<li>Data Storage Service Providers</li>
						<br />
						<li>Finance & Accounting Tools</li>
						<br />
					</ul>
					<p>
						We also may need to share your personal information in the following
						situations:
					</p>
					<ul>
						<li>
							<strong>Business Transfers.</strong> We may share or transfer your
							information in connection with, or during negotiations of, any
							merger, sale of company assets, financing, or acquisition of all
							or a portion of our business to another company.
						</li>
						<br />
						<li>
							<strong>Affiliates.</strong> We may share your information with
							our affiliates, in which case we will require those affiliates to
							honor this privacy notice. Affiliates include our parent company
							and any subsidiaries, joint venture partners, or other companies
							that we control or that are under common control with us.
						</li>
						<br />
						<li>
							<strong>Business Partners.</strong> We may share your information
							with our business partners to offer you certain products,
							services, or promotions.
						</li>
						<br />
					</ul>
					<br />
					<h3>VI. Third-Party Content and Integrations</h3>
					<br />
					<p>
						The Services, including our offer wall, may link to third-party
						websites, online services, or mobile applications and/or contain
						advertisements from third parties that are not affiliated with us
						and which may link to other websites, services, or applications.
						Accordingly, we do not make any guarantee regarding any such third
						parties, and we will not be liable for any loss or damage caused by
						the use of such third-party websites, services, or applications. The
						inclusion of a link towards a third-party website, service, or
						application does not imply an endorsement by us. We cannot guarantee
						the safety and privacy of data you provide to any third parties. Any
						data collected by third parties is not covered by this privacy
						notice. We are not responsible for the content or privacy and
						security practices and policies of any third parties, including
						other websites, services, or applications that may be linked to or
						from the Services. You should review the policies of such third
						parties and contact them directly to respond to your questions.
					</p>
					<br />
					<h3>VII. Revisions to the Privacy Policy</h3>
					<br />
					<p>
						We may update this Privacy Policy from time to time. The updated
						version will be indicated by an updated "Revised" date and the
						updated version will be effective as soon as it is accessible. If we
						make material changes to this privacy notice, we may notify you
						either by prominently posting a notice of such changes or by
						directly sending you a notification. We encourage you to review this
						privacy notice frequently to be informed of how we are protecting
						your information.
					</p>
					<br />
					<h3>
						VIII. How to Review, Update, or Delete the Data We Collect from You
					</h3>
					<br />
					<p>
						Based on the applicable laws of your country, you may have the right
						to request access to the personal information we collect from you,
						change that information, or delete it. To request to review, update,
						or delete your personal information, please contact us at
						witz-support@swipr.cc
					</p>
					<br />
				</Content>
			</ContentContainer>
		</>
	);
};

const ContentContainer = styled(Container)`
	padding-top: 153px;
	@media (max-width: 768px) {
		width: auto;
	}
`;

const Content = styled.div`
	margin: 50px 0;
	padding-bottom: 80px;
	@media (max-width: 768px) {
		margin: 20px 0;
		font-size: 14px;
		p {
			font-size: 14px;
		}
	}
`;
export default Privacy;
